export const DENTAL_PROBLEMS = [
  { icon: "PhoneMissed", text: "Calls go unanswered" },
  { icon: "ShieldAlert", text: "Insurance verification gets delayed" },
  { icon: "CalendarX", text: "Last-minute cancellations leave empty chairs" },
  { icon: "BellOff", text: "Recall patients aren't contacted consistently" },
  { icon: "FileClock", text: "Unscheduled treatment gets forgotten" },
  { icon: "MessageSquareX", text: "Patients don't always receive timely follow-up" },
];

export const DENTAL_DURING_HOURS = [
  "All incoming calls, if requested",
  "Overflow calls when the front desk is busy",
  "Missed-call recovery",
  "Patient callbacks",
  "Appointment requests",
  "Scheduling and rescheduling",
  "Routine practice FAQs",
  "Message capture and escalation",
];

export const DENTAL_SERVICES = [
  { icon: "PhoneCall", title: "Call Management", desc: "Inbound calls, overflow calls, missed-call callbacks and patient messages." },
  { icon: "CalendarCheck", title: "Appointment Scheduling", desc: "Book, reschedule and cancel appointments according to the practice's scheduling rules." },
  { icon: "CalendarSearch", title: "Schedule Gap Recovery", desc: "Monitor upcoming openings and contact approved ASAP/short-call patients to help fill last-minute cancellations." },
  { icon: "ShieldCheck", title: "Insurance Verification", desc: "Verify eligibility and benefits ahead of scheduled appointments and document the information in the practice's designated system." },
  { icon: "BellRing", title: "Recall & Reactivation", desc: "Contact patients who are due or overdue for recalls based on practice-approved lists and workflows." },
  { icon: "ClipboardList", title: "Unscheduled Treatment Follow-Up", desc: "Follow up with patients who have recommended treatment but have not yet scheduled." },
  { icon: "UserPlus", title: "New Patient Support", desc: "Capture required patient information, appointment needs and insurance details." },
  { icon: "CheckCircle2", title: "Appointment Confirmations", desc: "Help confirm upcoming appointments and identify potential cancellations earlier." },
];

export const DENTAL_STEPS = [
  { title: "Understand Your Practice", desc: "We learn your office hours, scheduling rules, call scripts, escalation protocols and workflows." },
  { title: "Connect", desc: "Your practice keeps its existing phone number. Call routing is configured according to the coverage model you choose." },
  { title: "Train", desc: "Your Medlyn VA is trained on your practice's approved workflows, systems and expectations." },
  { title: "Go Live", desc: "Medlyn begins supporting your front desk while performance and workflows are monitored." },
  { title: "Optimize", desc: "Call handling, scheduling, recalls, insurance verification and follow-up workflows are continuously reviewed and refined." },
];

export const DENTAL_COVERAGE = [
  {
    icon: "PhoneForwarded",
    title: "Overflow Support",
    desc: "Your existing front desk answers first. When they're busy or unable to answer, calls can overflow to Medlyn.",
    best: "Best for practices that already have a receptionist but need additional capacity.",
  },
  {
    icon: "Headset",
    title: "Virtual Front Desk",
    desc: "Medlyn handles designated front-desk workflows and call coverage during agreed hours.",
    best: "Best for practices looking to expand administrative capacity without adding another traditional in-office position.",
    featured: true,
  },
  {
    icon: "Clock4",
    title: "24/7 Coverage",
    desc: "Combine human Dental VA support with after-hours AI-assisted call handling so patients can receive support beyond normal office hours.",
    best: "Best for practices that want extended availability and fewer missed patient opportunities.",
  },
];

export const DENTAL_WHY = [
  { icon: "GraduationCap", text: "Healthcare-focused training" },
  { icon: "Workflow", text: "Practice-specific workflows" },
  { icon: "Bot", text: "Human + AI support" },
  { icon: "Clock4", text: "24/7 call coverage options" },
  { icon: "Users", text: "Works alongside your existing team" },
  { icon: "Gauge", text: "Structured quality monitoring" },
  { icon: "ShieldCheck", text: "HIPAA-conscious workflows and technology" },
];

export const DENTAL_FAQS = [
  {
    q: "Which practice management systems do you work with?",
    a: "Our Dental VAs are trained to work inside your existing practice management system — including Dentrix, Eaglesoft, Open Dental, Curve Dental, Denticon and others. We work with the scheduling rules, templates and workflows you already use; there's no new software for your team to learn.",
  },
  {
    q: "Will patients know they're talking to Medlyn?",
    a: "Your VA answers as part of your practice, using your practice name and your approved call scripts and tone. The goal is a seamless patient experience — patients simply reach a helpful, well-trained member of your front-desk team.",
  },
  {
    q: "Does this replace my front desk team?",
    a: "No. Medlyn is designed to work alongside your existing front desk — absorbing overflow calls, after-hours coverage and repetitive follow-up work so your in-office team can focus on the patients standing in front of them.",
  },
  {
    q: "How does the pilot program work?",
    a: "We typically start with one clearly scoped workflow — like overflow call answering or recall outreach — for a limited trial period. You see the results before expanding coverage. Mention the pilot when you book your consultation and we'll design one around your practice.",
  },
  {
    q: "How long does it take to get started?",
    a: "Most practices go live within a couple of weeks: we document your workflows and scripts, configure call routing around your existing number, train your dedicated VA on your systems, and monitor performance closely during ramp-up.",
  },
  {
    q: "How are HIPAA and patient privacy handled?",
    a: "Engagements are backed by a Business Associate Agreement (BAA). VAs complete HIPAA training, work over encrypted access-controlled channels, and follow practice-approved workflows for handling patient information. Ask us for our HIPAA statement and BAA during your consultation.",
  },
  {
    q: "What happens after hours?",
    a: "Outside your normal hours, calls can be handled by Medlyn's AI-assisted call support following your approved workflows — capturing appointment requests, answering routine questions, taking messages and escalating anything that needs human attention.",
  },
  {
    q: "How much does it cost?",
    a: "Pricing depends on your coverage model (overflow, virtual front desk, or 24/7), call volume and the workflows you want covered. We'll give you custom pricing on a free 15-minute consultation — no commitment required.",
  },
];

export const DENTAL_HELP_OPTIONS = [
  "24/7 Call Support",
  "Overflow Calls",
  "Scheduling",
  "Insurance Verification",
  "Recall & Reactivation",
  "Unscheduled Treatment Follow-Up",
  "Complete Dental Virtual Front Desk",
  "Other",
];
